import React from "react";
import { Box, Typography, Grid, Paper } from "@mui/material";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";

const TableReport = ({ salesData, colName, data }) => {
  return (
    <Box
      sx={{
        py: "20px",
        px: { xs: "10px", sm: "50px" },
        background: "#fff",
        borderRadius: "12px",
        fontFamily: "'Montserrat', sans-serif",
      }}
    >
      <Grid container spacing={1}>
        <Grid
          container
          spacing={1}
          sx={{ borderBottom: "1px solid #1E1E1E", padding: "10px 0px" }}
        >
          <Grid item xs={6}>
            <Typography
              fontWeight={500}
              color="primary"
              sx={{
                paddingLeft: "46px",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              Item name
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography
              fontWeight={500}
              color="primary"
              sx={{
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              Qty
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography
              fontWeight={500}
              color="primary"
              sx={{
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              Amount
            </Typography>
          </Grid>
        </Grid>

        {/* Header */}
        <Grid
          container
          mt={2}
          sx={{
            height: "50vh",
            overflow: "auto",
            marginTop: "10px",
            paddingRight: "10px",
          }}
        >
          <Grid item xs={12}>
            {/* Data Rows */}
            {data.map((item, idx) => (
              <Grid
                container
                key={idx}
                elevation={2}
                sx={{ borderRadius: "10px", my: "5px", background: "#E3E3FF" }}
              >
                <Grid item xs={6}>
                  <Box p={1}>
                    <Typography
                      fontWeight={500}
                      color="#000000"
                      sx={{
                        paddingLeft: "40px",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                    >
                      {item.itemDescription}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={3}>
                  <Box p={1}>
                    <Typography
                      fontWeight={500}
                      color="#000000"
                      sx={{
                        paddingLeft: "7px",
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                    >
                      {item.quantity?.toFixed(1)}
                    </Typography>
                  </Box>
                </Grid>
                {/* <Grid item xs={3}>
                  <Box p={1}>
                    <Typography fontWeight={500} color="#000000">
                      {item.amount?.toFixed(2)}
                    </Typography>
                  </Box>
                </Grid> */}
                <Grid
                  ite
                  xs={3}
                  sx={{
                    display: "flex",
                    // justifyContent: "center",
                    alignItems: "center",
                    paddingLeft: {xs:"1px", sm:"10px"},
                  }}
                >
                  <CurrencyRupeeIcon color="#000000" fontSize="10px" />
                  <Typography
                    color="#000000"
                    sx={{
                      textOverflow: "ellipsis",
                      fontWeight: 500,
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      paddingLeft: "8px",
                    }}
                  >
                    {item.amount?.toFixed(2)}
                  </Typography>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TableReport;
